import styled from 'styled-components';
import {SideBox} from "../etc/LBox/LBox";
import {Spacer} from "oui";

const KTIOSWarningWrap = styled.div`
  color: var(--surface-on-surface-variant1, #FF3A4A);
  font-feature-settings: 'clig' off, 'liga' off;

  /* txt/Trg16 */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`

const KTIOSWarning = () => {
  return (
      <SideBox>
        <KTIOSWarningWrap>
          본인 인증 완료 후 3초만 기다려주세요!
        </KTIOSWarningWrap>
      </SideBox>
  );
}

export default KTIOSWarning;